<mat-card class="decoration-card">
    <mat-card-content>

        <!--mat-toolbar>
            <mat-button-toggle-group class="mat-button-toggle-group" (change)="onEditModeChange($event.value)" *ngIf="isWithEditRight">
                <mat-button-toggle value="read" matTooltip="readonly">
                    <mat-icon>subject</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="edit" matTooltip="edit mode">
                    <mat-icon>edit</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>

            <span class="example-spacer"></span>

            <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
                <mat-icon>favorite</mat-icon>
            </button>
            <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
                <mat-icon>share</mat-icon>
            </button>
        </mat-toolbar-->

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- sn Column -->
            <ng-container matColumnDef="sn">
                <th mat-header-cell *matHeaderCellDef> SN </th>
                <td mat-cell *matCellDef="let element"> {{element.sn}} </td>
            </ng-container>

            <!-- description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <!-- type Column -->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element"> {{element.type_text}} </td>
            </ng-container>

            <!-- closed Column -->
            <ng-container matColumnDef="closed">
                <th mat-header-cell *matHeaderCellDef> Closed </th>
                <td mat-cell *matCellDef="let element"> {{element.closed_text}} </td>
            </ng-container>

            <!-- test sn Column -->
            <ng-container matColumnDef="testSN">
                <th mat-header-cell *matHeaderCellDef> Test SN </th>
                <td mat-cell *matCellDef="let element"> {{element.test_sn}} </td>
            </ng-container>

            <!-- test name Column -->
            <ng-container matColumnDef="testName">
                <th mat-header-cell *matHeaderCellDef> Test Name </th>
                <td mat-cell *matCellDef="let element"> {{element.test_name}} </td>
            </ng-container>

            <!-- step sn Column -->
            <ng-container matColumnDef="stepSN">
                <th mat-header-cell *matHeaderCellDef> Step SN </th>
                <td mat-cell *matCellDef="let element"> {{element.step_sn}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectRecommendation(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>